<script lang="ts">
export default { name: "ModalContainer" };
</script>

<script setup lang="ts">
import * as vue from "vue";

export type ModalContainerOptions = {
	height?: string;
	width?: string;
};

defineProps({
	options: {
		type: Object as vue.PropType<ModalContainerOptions>,
		default: null,
		required: false
	}
});

const isVisible = vue.ref(false);

const hide = () => {
	isVisible.value = false;
	document.body.classList.remove("no-scroll");
};

const show = () => {
	isVisible.value = true;
	document.body.classList.add("no-scroll");
};

defineExpose({ hide, show });

vue.onUnmounted(() => {
	document.body.classList.remove("no-scroll");
});
</script>

<template>
	<div v-if="isVisible" class="modal" @click="hide">
		<button class="modal_close-button" @click.stop="hide" aria-label="Close">
			<i class="pi pi-times"></i>
		</button>
		<div class="modal_slot-content">
			<slot></slot>
		</div>
	</div>
</template>

<style lang="scss">
.modal {
	align-items: center;
	background-color: rgba(0, 0, 0, 0.85);
	cursor: pointer;
	display: flex;
	height: 100%;
	justify-content: center;
	left: 0;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 1000;
}

.modal_slot-content {
	width: 90vw;
	height: 90vh;
}

.modal_slot-content > img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.modal_close-button {
	position: absolute;
	top: 1rem;
	right: 1rem;
	min-width: 44px;
	min-height: 44px;
	width: 44px;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.2);
	border: none;
	border-radius: 50%;
	color: white;
	font-size: 1.25rem;
	cursor: pointer;
	z-index: 1001;
	transition: background 0.2s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.4);
	}
}
</style>
